import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import {setCreateNewCodeList, setCreateNewCodeSave} from 'Store/OrderManagement/AcquisitionCode/AcquisitionCodeAction';
import { GET_CREATE_NEW_CODE_LIST, GET_CREATE_NEW_CODE_SAVE } from 'Store/OrderManagement/AcquisitionCode/AcquisitionCodeType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';

function* getCreateAcquisitionCodeListSaga(payload?: any): any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `acquisition/list`,
        payload : payload.payload
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setCreateNewCodeList(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setCreateNewCodeList([]))
        yield put(globalLoaderText(""));
    }
}

function* getCreateAcquisitionCodeSaveSaga(payload?: any): any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `acquisition/code`,
        payload : payload.payload
    }
    try {
        yield put(globalLoaderText("Adding Acquisition details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setCreateNewCodeSave(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setCreateNewCodeSave({}))
        yield put(globalLoaderText(""));
    }
}

function* watchDataSync() {
    yield takeEvery(GET_CREATE_NEW_CODE_LIST, getCreateAcquisitionCodeListSaga);
    yield takeEvery(GET_CREATE_NEW_CODE_SAVE, getCreateAcquisitionCodeSaveSaga)
}

export default function* combinedSaga() {
    yield all([
        watchDataSync()
    ])
  }
